import AppImage from '@/components/ui/AppImage';

export default function StorySection() {
  const stories = [
  {
    id: 'story_1',
    title: 'Our Beginning',
    content:
    'Founded in 2015, Classic24 Digital Solutions started with a vision to democratize digital marketing. We believed every business, regardless of size, deserved access to premium digital services.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1feda45ac-1767136399160.png",
    alt: 'Team of professionals collaborating in modern office space with laptops and creative materials',
    reverse: false
  },
  {
    id: 'story_2',
    title: 'Our Growth',
    content:
    'Over the years, we\'ve expanded our services from social media marketing to comprehensive digital solutions. Today, we serve 50+ industries with a team of passionate experts dedicated to your success.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e3f75a0a-1768220029762.png",
    alt: 'Diverse team working together on digital marketing campaign in collaborative workspace',
    reverse: true
  },
  {
    id: 'story_3',
    title: 'Our Future',
    content:
    'We\'re constantly evolving, adopting the latest technologies and strategies to keep our clients ahead of the curve. Our commitment to innovation ensures your brand stays relevant in the ever-changing digital landscape.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e6f34e1b-1766322876007.png",
    alt: 'Futuristic digital workspace with advanced technology and creative professionals planning strategies',
    reverse: false
  }];


  return (
    <section className="py-20 md:py-32 bg-background">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16 reveal">
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="w-[2px] h-4 bg-amber-500" />
            <span className="text-[10px] uppercase tracking-[0.3em] font-bold text-zinc-400">
              Our Story
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6 text-white">
            A Journey of<br />Digital Excellence
          </h2>
        </div>

        <div className="space-y-24">
          {stories?.map((story, idx) =>
          <div
            key={story?.id}
            className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center reveal ${
            story?.reverse ? 'lg:flex-row-reverse' : ''}`
            }
            style={{ transitionDelay: `${idx * 150}ms` }}>
            
              <div className={story?.reverse ? 'lg:order-2' : ''}>
                <div className="relative rounded-2xl overflow-hidden group">
                  <AppImage
                  src={story?.image}
                  alt={story?.alt}
                  className="w-full h-[400px] object-cover grayscale group-hover:grayscale-0 transition-all duration-700" />
                
                  <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-all" />
                </div>
              </div>
              <div className={story?.reverse ? 'lg:order-1' : ''}>
                <h3 className="text-3xl md:text-4xl font-bold mb-6 text-white">
                  {story?.title}
                </h3>
                <p className="text-lg text-zinc-400 leading-relaxed">
                  {story?.content}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

}